import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@common/core/services/guards';

const routes: Routes = [
  { path: '', redirectTo: 'cerca', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'm/auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  // NOTE: do not change the order or routes
  {
    path: 'm',
    loadChildren: () => import('./modules/mobile/mobile.module').then(m => m.MobileModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/desktop/desktop.module').then(m => m.DesktopModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
